export default __webpack_public_path__ + "997a624bf66185c5765fcd8820b62986.png";